import { fetchAddressFormatConfiguration } from '../services/configurationService.js';
import { setAddressFormats } from '../reducers/configurationReducer.js';

const handleError = (error) => {
    console.log('An error happened, please pass it onto the global error handler', error);
    console.error('An error happened, please pass it onto the global error handler', error);
};

export const getAddressFormatConfiguration = (territoryId) => {
    return (dispatch, getState) => {
        const me = getState().meDetails.meState || {};
        const loggedIn = me.LOGGED_IN;
        if (loggedIn) {
            return fetchAddressFormatConfiguration(territoryId)
                .then((config) => {
                    dispatch(setAddressFormats(config));
                })
                .catch(handleError.bind(dispatch));
        }
    };
};
